export const subTextStyle = {
    color: "text.secondary",
    variant: "body1",
    marginBottom: "10px",
};
